import { ChangeDetectionStrategy, Component } from '@angular/core';
@Component({
  selector: 'fyi-popup',
  templateUrl: './fyi-popup.component.html',
  styleUrls: ['./fyi-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FyiPopupComponent {}
